import { render, staticRenderFns } from "./POIManagerView.vue?vue&type=template&id=04e1830d"
import script from "./POIManagerView.vue?vue&type=script&lang=js"
export * from "./POIManagerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports